import ConnectorViewMappingPrint from '../../../../components/connector_views/connector_mapping/print'

const ConnectorViewMappingsPrintPage = () => {
  return <ConnectorViewMappingPrint />
}

export default ConnectorViewMappingsPrintPage
